export function formatBytes(
  bytes: number,
  { decimals = 2, base = 1024 }: { decimals?: number; base?: 1000 | 1024 } = {}
) {
  if (!Number.isFinite(bytes)) return '—';
  if (bytes === 0) return '0 B';

  const k = base;
  const units =
    base === 1024
      ? ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB']
      : ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

  const i = Math.floor(Math.log(Math.abs(bytes)) / Math.log(k));
  const value = bytes / Math.pow(k, i);
  return `${value.toFixed(decimals)} ${units[i]}`;
}

// convert a backend image url (absolute or relative) into the /image proxy path
export function toProxyImageUrl(url?: string | null): string | null {
  if (!url) return null;

  let path = url;
  if (/^https?:\/\//i.test(url)) {
    try {
      path = new URL(url).pathname;
    } catch {
      path = url;
    }
  }

  return '/image/' + path.replace(/^\/+/, '');
}
